// Explicit registry: catalogs and their coverage policies ship together.
module.exports = ['navigation', 'events', 'performances', 'shared', 'editor', 'organization-all', 'workflows-all', 'admin-all', 'shell-all', 'field-types', 'integration-corvus']
